import memoize from 'transmute/memoize';
import { Set as ImmutableSet } from 'immutable';
import { createActionIdMap, findAllDecendantsActionIds } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
export const sumObjectsInActionsCount = memoize(({
  actionIdsToSum,
  objectsInActions
}) => {
  if (!actionIdsToSum.size || !objectsInActions.length) {
    return 0;
  }
  return objectsInActions.filter(objectsInAction => actionIdsToSum.includes(objectsInAction.actionId)).reduce((total, obj) => total + obj.count, 0);
});
export const sumChildObjectsInActionCount = ({
  rootActionId,
  flow,
  objectsInActions
}) => {
  if (!flow || !objectsInActions) {
    return 0;
  }
  const actionIdMap = createActionIdMap(flow, false);
  const childActionIds = ImmutableSet(findAllDecendantsActionIds({
    actionIdMap,
    actions: flow.getActions(),
    rootActionId
  }));
  return sumObjectsInActionsCount({
    actionIdsToSum: childActionIds,
    objectsInActions
  });
};